import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d6831e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 5L4.99997 15.0001",
    stroke: "#777777",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 15L4.99997 4.99993",
    stroke: "#777777",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "close__modal_ping",
    onClick: _cache[0] || (_cache[0] = () => $props.setModal(false))
  }, [
    _hoisted_1,
    _createElementVNode("p", null, _toDisplayString(_ctx.getStaticLanguage.closeModal), 1)
  ]))
}